import { _ as _defineProperty } from '../../defineProperty-18999f8e.js';
import { ZOOM_MIN, ZOOM_MAX, ZOOM_SPEED } from '../../configs/index.js';
import { p as getNodeAttrs, s as setNodeAttrs, t as drawNode } from '../../selectors-f64b5778.js';
import calcStagePosition from '../../utils/calcStagePosition/index.js';
import { hasHorizontalScroll, hasVerticalScroll } from '../../utils/hasScroll/index.js';
import { calculateCanvasHeight } from '../../utils/calculateCanvasHeight/index.js';
import { _ as _baseGetTag, i as isObjectLike_1, a as isObject_1 } from '../../isObjectLike-66611f04.js';
import { _ as _typeof } from '../../typeof-92b42de1.js';
import { getLayerManipulations } from '../../external/index.js';
import { getPositionAfterZoom } from '../getPositionAfterZoom/index.js';
import '../../slicedToArray-26803f33.js';
import '../../unsupportedIterableToArray-577176bf.js';
import '../../toConsumableArray-2a2700d9.js';
import '../../_commonjsHelpers-1789f0cf.js';

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */

function baseClamp$1(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }

    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }

  return number;
}

var _baseClamp = baseClamp$1;

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;
/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */

function trimmedEndIndex$1(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}

  return index;
}

var _trimmedEndIndex = trimmedEndIndex$1;

var trimmedEndIndex = _trimmedEndIndex;
/** Used to match leading whitespace. */

var reTrimStart = /^\s+/;
/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */

function baseTrim$1(string) {
  return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
}

var _baseTrim = baseTrim$1;

var baseGetTag = _baseGetTag,
    isObjectLike = isObjectLike_1;
/** `Object#toString` result references. */

var symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */

function isSymbol$1(value) {
  return _typeof(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
}

var isSymbol_1 = isSymbol$1;

var baseTrim = _baseTrim,
    isObject = isObject_1,
    isSymbol = isSymbol_1;
/** Used as references for various `Number` constants. */

var NAN = 0 / 0;
/** Used to detect bad signed hexadecimal string values. */

var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */

var reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */

var reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */

var freeParseInt = parseInt;
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */

function toNumber$1(value) {
  if (typeof value == 'number') {
    return value;
  }

  if (isSymbol(value)) {
    return NAN;
  }

  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? other + '' : other;
  }

  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }

  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
}

var toNumber_1 = toNumber$1;

var baseClamp = _baseClamp,
    toNumber = toNumber_1;
/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */

function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }

  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }

  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }

  return baseClamp(toNumber(number), lower, upper);
}

var clamp_1 = clamp;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var getStage = function getStage(provider) {
  return provider.stage;
};

function stageZoomReposition(provider, _ref) {
  var toZoom = _ref.toZoom,
      _ref$deltaY = _ref.deltaY,
      deltaY = _ref$deltaY === void 0 ? 0 : _ref$deltaY,
      _ref$toCenter = _ref.toCenter,
      toCenter = _ref$toCenter === void 0 ? false : _ref$toCenter,
      _ref$min = _ref.min,
      min = _ref$min === void 0 ? ZOOM_MIN : _ref$min,
      _ref$max = _ref.max,
      max = _ref$max === void 0 ? ZOOM_MAX : _ref$max,
      _ref$speed = _ref.speed,
      speed = _ref$speed === void 0 ? ZOOM_SPEED : _ref$speed,
      calculateCanvasHeightParams = _ref.calculateCanvasHeightParams;
  var stage = getStage(provider);

  var _getNodeAttrs = getNodeAttrs(stage),
      oldScale = _getNodeAttrs.scaleX,
      width = _getNodeAttrs.width,
      height = _getNodeAttrs.height;

  var calculatedScale = toZoom || oldScale * Math.pow(speed, deltaY);
  var nextScale = clamp_1(calculatedScale, min, max);
  var canvasHeight = Math.max(nextScale * calculateCanvasHeightParams.cssHeight, calculateCanvasHeight(_objectSpread(_objectSpread({}, calculateCanvasHeightParams), {}, {
    zoom: nextScale
  })));
  var position = getPositionAfterZoom(provider, {
    canvasHeight: canvasHeight,
    nextScale: nextScale,
    oldScale: oldScale,
    toCenter: toCenter || !!toZoom,
    verticalScrollParams: calculateCanvasHeightParams
  }); // maximum scaled width minus the width needed by the canvas

  var maxX = width * (nextScale - 1);
  var maxY = canvasHeight - height;
  var clampedPosition = {
    x: Math.min(Math.abs(position.x), maxX),
    y: Math.min(Math.abs(position.y), maxY)
  };
  var x = !hasHorizontalScroll(nextScale) ? position.x : -clampedPosition.x;
  var y = !hasVerticalScroll(_objectSpread(_objectSpread({}, calculateCanvasHeightParams), {}, {
    zoom: nextScale
  })) ? position.y : -clampedPosition.y;
  setNodeAttrs(stage, {
    scaleX: nextScale,
    scaleY: nextScale,
    position: {
      x: x,
      y: y
    }
  });
  getLayerManipulations().setZoom(nextScale);
  drawNode(stage);
  return {
    zoom: nextScale,
    left: x,
    top: y
  };
}

function stageScaleChange(provider, _ref2) {
  var scaleX = _ref2.scaleX,
      scaleY = _ref2.scaleY;
  var stage = getStage(provider);
  setNodeAttrs(stage, {
    scaleX: scaleX,
    scaleY: scaleY
  });
}

function stageReposition(provider, _ref3) {
  var x = _ref3.x,
      y = _ref3.y,
      zoom = _ref3.zoom,
      hasVerticalScrollParams = _ref3.hasVerticalScrollParams;
  var stage = getStage(provider);

  var _x = zoom > 1 ? x : getNodeAttrs(stage).position.x;

  var _y = hasVerticalScroll(_objectSpread(_objectSpread({}, hasVerticalScrollParams), {}, {
    zoom: zoom
  })) ? y : getNodeAttrs(stage).position.y;

  setNodeAttrs(stage, {
    position: {
      x: _x,
      y: _y
    }
  });
  drawNode(stage);
}

function resetStagePosition(provider) {
  var stage = getStage(provider);
  setNodeAttrs(getStage(provider), {
    position: {
      x: 0,
      y: 0
    },
    scaleX: 1,
    scaleY: 1
  });
  drawNode(stage);
}

var getStagePosition = function getStagePosition(provider, hasVerticalScrollParams) {
  var ignoreScroll = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  return calcStagePosition(getStage(provider), hasVerticalScrollParams, ignoreScroll);
};

export { getStagePosition, resetStagePosition, stageReposition, stageScaleChange, stageZoomReposition };
